import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { FileInfo, FileRestrictions, RemoveEvent, SuccessEvent, UploadEvent } from '@progress/kendo-angular-upload';
import { environment } from '../../../../../../environments/environment';
import { ConfigService } from '../../../../services/config.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  uploadSaveUrl = environment.apiUrl + ConfigService.APIs.endPoints.UPLOAD.UPLOAD_FILES_KENDO; // should represent an actual API endpoint
  uploadRemoveUrl = environment.apiUrl + ConfigService.APIs.endPoints.UPLOAD.REMOVE_FILES_KENDO;//'https://localhost:44359/api/Admin/RemoveFile'; // should represent an actual API endpoint
  //myFiles: Array<FileInfo> = [];
  @Input() public myFiles: Array<FileInfo> = [];
  @Input() public multiple: Boolean;//multi or single
  @Input() public uploadFolderPath: String = '';//
  @Input() public fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png"],
  };
  @Output() public fileSelect: EventEmitter<SelectEvent> = new EventEmitter();
  @Output() public uploadSuccess: EventEmitter<SuccessEvent> = new EventEmitter();
  @Output() public uploadComplete: EventEmitter<boolean> = new EventEmitter();
  @Output() public uploadRemove: EventEmitter<RemoveEvent> = new EventEmitter();
    uploadedFilePaths: any;
  //apiURL = environment.apiUrl + ConfigService.APIs.endPoints.UPLOAD.UPLOAD_FILES_KENDO;
  constructor() { }

  ngOnInit() {
  }
  onUpload(e: UploadEvent) {
    e.data = {
      uploadFolder: this.uploadFolderPath,
      fileNameRename: !this.multiple  /// for multiple file upload renaming the file will create problem for remove API..so renaming is false if multiple is true
    };
    //e.data = this.uploadFolderPath;
    var a = this.multiple;
  }
  onSelect(evt) {
    // var fileNameArray = this.myFiles.map(function (item) { return item.name });
    // var isDuplicate = fileNameArray.some(function (item, idx) {
    //   return fileNameArray.indexOf(item) != idx
    // });
    
var selectedFileName = evt.files[0].name;  
    var hasDuplicates = this.myFiles && this.myFiles.some(function (currentObject) {
      return selectedFileName === currentObject.name;
    });
     if (hasDuplicates) {
      alert("Duplicate file selected");
      evt.preventDefault();
    }
    else{
      if (evt.files[0].rawFile) {
            const reader  = new FileReader();
            reader.onloadend = () => {
                this.myFiles.push({...evt.files[0], src: <string>reader.result});
            };
      }
       this.fileSelect.emit(evt);
    }
  }
  public onSuccess(evt: SuccessEvent) {
    if (evt.operation === 'upload') {
      this.uploadedFilePaths = evt.response.body.paths;//for multiple false
      console.log('The ' + evt.operation + ' was successful!');
      this.uploadSuccess.emit(evt);
    }
  }
  public onRemove(evt: RemoveEvent) {
    evt.data = {
      uploadFiles: this.multiple ? `${this.uploadFolderPath}/${evt.files[0].name}` : this.uploadedFilePaths,

    };
    this.uploadRemove.emit(evt);
  }
  public onComplete() {
    this.uploadComplete.emit(true);
  }
}
